<template>
  <CustomSelect
    class="w-100"
    inputId="weekNumberPicker"
    inputLabel="نمایش جلسات برای"
    v-model="selectedWeekNumber"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="weekNumberOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedWeekNumber: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedWeekNumber) {
      this.selectedWeekNumber = this.defaultSelectedWeekNumber;
    }
  },
  data() {
    return {
      selectedWeekNumber: 0,
      weekNumberOptions: [
        {
          text: "هشت هفته پیش",
          value: -7,
        },
        {
          text: "هفت هفته پیش",
          value: -6,
        },
        {
          text: "شش هفته پیش",
          value: -5,
        },
        {
          text: "پنج هفته پیش",
          value: -4,
        },
        {
          text: "چهار هفته پیش",
          value: -3,
        },
        {
          text: "سه هفته پیش",
          value: -2,
        },
        {
          text: "دو هفته پیش",
          value: -1,
        },
        {
          text: "هفته پیش",
          value: 0,
        },
        {
          text: "هفته جاری",
          value: 1,
        },
        {
          text: "هفته 2",
          value: 2,
        },
        {
          text: "هفته 3",
          value: 3,
        },
        {
          text: "هفته 4",
          value: 4,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
